import React from 'react';
import { Button, Result } from 'antd';

const NotFound = function (props) {
    return (
        <div style={{
            minHeight: '80vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px'
        }}>
            <Result
                status="404"
                title="404"
                subTitle="抱歉，您访问的页面不存在或已被移除。"
                extra={
                    props.homeUrl && <Button type="primary" onClick={() => {
                        window.location.href = props.homeUrl;
                    }}>
                        返回首页
                    </Button>
                }
            />
        </div>
    );
};

export default NotFound;